import { MONTHS_STAR, MonthStar } from "./MonthStar.js";

/**
 * Validates the month number ("01"-"12") or "*".
 */
export function validateMonthStar(month: string): MonthStar {
  const cast = month as MonthStar;
  if (MONTHS_STAR.includes(cast)) {
    return cast;
  } else {
    throw new Error(`Invalid month: ${month}.`);
  }
}
